import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

// Public locale files are not fingerprinted by Vite. Keep this value distinct
// for each locale-content release so clients cannot reuse a stale translation file.
const TRANSLATION_ASSET_VERSION = '20260902-deep-dive-ui-v2';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'fr',
    supportedLngs: ['fr', 'en'],
    debug: import.meta.env.DEV,

    interpolation: {
      escapeValue: false, // React already escapes
    },

    backend: {
      loadPath: `/locales/{{lng}}/{{ns}}.json?v=${TRANSLATION_ASSET_VERSION}`,
      requestOptions: {
        cache: 'no-store',
      },
    },

    detection: {
      order: ['localStorage'],
      caches: ['localStorage'],
    },

    react: {
      useSuspense: false,
    },
  });

export default i18n;
